import React from 'react'
import { SKILL_LEVELS } from '../../../../constants/skillLevels'

export default function LeagueLevelsSection({
  leagueLevels,
  levelToAdd,
  setLevelToAdd,
  handleAddLevel,
  handleDeactivateLevel,
}) {
  return (
    <div className="form-section">
      <h3>League Levels</h3>
      <div className="d-flex gap-2 align-items-end mb-3">
        <div className="form-group mb-0">
          <label htmlFor="level_to_add">Add Skill Level</label>
          <select
            id="level_to_add"
            value={levelToAdd}
            onChange={(e) => setLevelToAdd(e.target.value)}
          >
            <option value="">Select level</option>
            {SKILL_LEVELS.filter(
              (level) =>
                !leagueLevels.some(
                  (ll) =>
                    Number(ll.skill_level) === level.value &&
                    ll.status === 'active',
                ),
            ).map((level) => (
              <option key={level.value} value={level.value}>
                {level.label}
              </option>
            ))}
          </select>
        </div>
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={handleAddLevel}
          disabled={!levelToAdd}
          data-testid="add-league-level-btn"
        >
          Add Level
        </button>
      </div>
      <ul className="list-group">
        {leagueLevels.map((level) => (
          <li
            className="list-group-item d-flex justify-content-between align-items-center"
            key={level.id}
            data-testid={`league-level-${level.skill_level}`}
          >
            <span>
              {level.skill_level} -{' '}
              <strong>
                {level.status === 'inactive' ? 'Inactive' : 'Active'}
              </strong>
            </span>
            {level.status !== 'inactive' && (
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={() => handleDeactivateLevel(Number(level.skill_level))}
                data-testid={`deactivate-level-${level.skill_level}`}
              >
                Deactivate
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
